<template>

  <div>

    <list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      @refetchData="refetchData"
      @reopenForm="reopenForm"
    />

    <edit-data
      :is-add-new-user-sidebar-active-edit.sync="isAddNewUserSidebarActiveEdit"
      @refetchData="refetchData"
      @reopenForm="reopenFormEdit"
      :userData="userData"
    />

    <!-- Filters -->
    <list-filters
      :trigger-filter.sync="triggerFilter"
      :data-filter.sync="dataFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <!-- <b-button
                variant="primary"
                @click="isAddNewUserSidebarActive = true"
              >
                <span class="text-nowrap">Tambah Jadwal</span>
              </b-button> -->
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <!-- <template #cell(name)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.name)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                title="Lihat Profil"
              />
            </template>
          </b-media>
        </template> -->

        <!-- <template #cell(email)="data">
          <b-media vertical-align="center">
            {{ data.item.email }}
          </b-media>
        </template>

        <template #cell(role)="data">
          <b-media vertical-align="center">
            {{ data.item.v1 }}
          </b-media>
        </template> -->

        <template #cell(status)="data">
          <b-media vertical-align="center">
            <b-badge pill :variant="'light-primary'" v-if="data.item.status === 'Terjadwal'">Terjadwal</b-badge>
            <b-badge pill :variant="'light-success'" v-if="data.item.status === 'Selesai'">Selesai</b-badge>
          </b-media>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
            class="mr-1 mb-1 btn-icon btn btn-relief-primary"
            variant="primary"
            @click="login(data.item.email, data.item.token)"
            title="Log In"
            :disabled="isDisabled == 'ya'"
          >
            <feather-icon icon="LogInIcon" />
          </b-button>

          <b-button
            class="mr-1 mb-1 btn-icon btn btn-relief-primary"
            variant="primary"
            @click="kirimUlang(data.item.uuid)"
            title="Kirim Ulang Jadwal"
            :disabled="isDisabled == 'ya'"
          >
            <feather-icon icon="MailIcon" />
          </b-button>

            <b-button
            class="mr-1 mb-1 btn-icon btn btn-relief-primary"
            variant="info"
             :to="{ name: 'jadwal-wawancara-edit', params: { uuid: data.item.uuid } }"
            title="Ubah Data"
          >
            <feather-icon icon="EditIcon" />
          </b-button>

          <!-- <b-button
            class="mb-1 btn-icon btn btn-relief-primary"
            variant="danger"
            @click="deleteData(data.item.uuid)"
            title="Delete"
          >
            <feather-icon icon="TrashIcon" />
          </b-button> -->
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Menampilkan {{ dataMeta.from }} per {{ dataMeta.to }} dari {{ dataMeta.of }} data </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  deleteDosen,
  loginPewawancara,
} from '@/connection-api/master'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/jadwal-wawancara/storeModule'
import useList from '@/connection-api/jadwal-wawancara/list'
import listAddNew from './ListAddNew.vue'
import listFilters from './ListFilters.vue'
import editData from './editData.vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import {
  Authlogin,
  setToken,
  setRefreshToken,
} from '@/connection-api/authentication'

export default {
  components: {
    listFilters,
    listAddNew,
    editData,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    BBadge,

    vSelect,
  },
  data() {
    return {
      counter: 0,
      userData: {},
      isDisabled: 'tidak',
    }
  },
  async mounted() {
  },
  methods: {
    login(email, token) {
      loginPewawancara({
        email: email,
        token: token,
        application_token: '',
        query: '',
        token_firebase: localStorage.getItem('tokenFirebase'),
        login_sebagai: '',
      })
        .then(response => {
          if (response.data.success == false) {
            this.loading = 0
            this.$swal({
              title: 'Wawancara',
              html: `${response.data.status.message}`,
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          } else {
            this.loading = 0
            this.$swal({
              title: 'Wawancara',
              html: `${response.data.status.message}`,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            
            const { member, urlCallback } = response.data.data

            localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
            localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

            // Remove userData from localStorage
            localStorage.removeItem('userData')
            localStorage.removeItem('adminUserData')
            localStorage.removeItem('token')
            localStorage.removeItem('tipe')

            // Reset ability
            this.$ability.update(initialAbility)

            setToken(response.data.data.accessToken)
            setRefreshToken(response.data.data.refreshToken)

            localStorage.setItem('token', token)
            localStorage.setItem('userData', JSON.stringify(member))
            localStorage.setItem('tipe', 'wawancara')
            this.$ability.update(member.ability)
            if (urlCallback === '') {
              this.$router.push(`/form-pewawancara/wawancara/${token}`)
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Selamat Datang ${member.fullName || member.username}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: 'Anda telah berhasil masuk PPDB Online. Sekarang Anda bisa mulai menjelajah!',
                    },
                  })
                })
            } else {
              localStorage.setItem('urlCallback', urlCallback)
              window.location.href = urlCallback
            }
          }
        })
    },
    kirimUlang(uuid) {
      this.userData.uuid = uuid
      this.isDisabled = 'ya'
      store.dispatch('jadwal-wawancara/resendData', this.userData)
        .then(response => {
          if (response.data.success === true) {
            this.makeToast('success', 'Resend success.')
            this.isDisabled = 'tidak'
          } else {
            this.makeToast('danger', response.data.message)
          }
        })
        .catch(error => {
        })
    },
    editData(uuid) {
        const data = {
          uuid: uuid,
        }
        store.dispatch('jadwal-wawancara/fetchData', data)
          .then(response => {
            this.userData = response.data.data
            this.isAddNewUserSidebarActiveEdit = true
          })
          .catch(error => {
          })
    },
    reopenForm(){
      this.isAddNewUserSidebarActive = false
      setTimeout(() => {
        this.isAddNewUserSidebarActive = true
      }, 100);
    },
    reopenFormEdit(){
      this.isAddNewUserSidebarActiveEdit = false
      setTimeout(() => {
        this.isAddNewUserSidebarActiveEdit = true
      }, 100);
    },
    deleteData(uuid){
      if(window.confirm('Apakah anda yakin?'))
      {
        var data = {
          uuid: uuid,
        }
        store.dispatch('jadwal-wawancara/deleteData', data)
          .then(response => {
            this.makeToast('success', 'Delete Data Jadwal Wawancara Berhasil Dilakukan')
            this.refetchData()
          })
          .catch(error => {
          })
      }
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Jadwal Wawancara',
        variant,
        solid: true,
        autoHideDelay: 3000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'jadwal-wawancara'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
    const isAddNewUserSidebarActiveEdit = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      triggerFilter,
      dataFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,
      isAddNewUserSidebarActiveEdit,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      triggerFilter,
      dataFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
